(() => {


  const formatPrinterHandle = (printer) => {
    return String(printer || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  };

  const params = new URLSearchParams(window.location.search);
  const printerFromUrl = (params.get('printer') || '').trim();

  const printer = printerFromUrl;

  const context = {
    printer: printer,
    compatibleHandles: new Set(),
    active: false,
    ready: null,

    isCompatible(handle) {
      return (
        this.active &&
        this.compatibleHandles.has(handle)
      );
    },

    clear() {
      this.printer = '';
      this.active = false;
      this.compatibleHandles.clear();


    }
  };

  window.UCWPrinterContext = context;

  /*
   * Geen actieve printercontext.
   */
  if (!printer) {
    context.ready = Promise.resolve(context);

    document.dispatchEvent(
      new CustomEvent('ucw:printer-context-ready', {
        detail: context
      })
    );

    return;
  }

  const printerHandle =
    formatPrinterHandle(printer);

  const root =
    window.Shopify?.routes?.root || '/';

  context.ready = fetch(
    `${root}collections/${printerHandle}/products.json?limit=250`
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          'Printercollectie niet gevonden'
        );
      }

      return response.json();
    })
    .then((data) => {
      const products = data.products || [];

      context.compatibleHandles = new Set(
        products.map((product) => product.handle)
      );

      /*
       * Als we op een PDP zitten:
       * eerst controleren of het hoofdproduct
       * daadwerkelijk bij deze printer hoort.
       */
      const pdp = document.querySelector(
        '[data-ucw-pdp-product]'
      );

      if (pdp) {
        const currentHandle =
          pdp.dataset.productHandle;

        if (
          currentHandle &&
          !context.compatibleHandles.has(currentHandle)
        ) {
          context.clear();

          document.dispatchEvent(
            new CustomEvent(
              'ucw:printer-context-ready',
              { detail: context }
            )
          );

          return context;
        }
      }

      context.active = true;

      /*
       * =====================================
       * PDP-hoofdproduct
       * =====================================
       */
      if (pdp) {
        const currentHandle =
          pdp.dataset.productHandle;

        if (
          currentHandle &&
          context.isCompatible(currentHandle)
        ) {
          const sourcePrinterEl =
            pdp.querySelector(
              '[data-pdp-source-printer]'
            );

          const printerNameEl =
            pdp.querySelector(
              '[data-pdp-source-printer-name]'
            );

          if (
            sourcePrinterEl &&
            printerNameEl
          ) {
            printerNameEl.textContent =
              context.printer;

            sourcePrinterEl.hidden = false;
          }

          /*
           * Algemene opgeslagen-printermelding
           * heeft dan geen toegevoegde waarde.
           */
          pdp.querySelectorAll(
            '.uw-printer-product-match'
          ).forEach((el) => {
            el.hidden = true;
          });
        }

        /*
         * Printercontext meenemen naar
         * varianten en gerelateerde producten.
         */
        pdp.querySelectorAll(
          '.uw-variant-snippet a[href], .uw-related a[href]'
        ).forEach((link) => {
          try {
            const url = new URL(
              link.href,
              window.location.origin
            );

            if (
              url.origin === window.location.origin &&
              url.pathname.startsWith('/products/')
            ) {
              url.searchParams.set(
                'printer',
                context.printer
              );

              link.href =
                url.pathname +
                url.search +
                url.hash;
            }
          } catch (error) {}
        });
      }

      /*
       * =====================================
       * Alle product-items op de pagina
       * =====================================
       */
      document.querySelectorAll(
        '[data-ucw-product-card]'
      ).forEach((card) => {
        const productHandle =
          card.dataset.productHandle;

        if (
          !productHandle ||
          !context.isCompatible(productHandle)
        ) {
          return;
        }

        const fit = card.querySelector(
          '[data-ucw-card-printer-fit]'
        );

        const printerName = card.querySelector(
          '[data-ucw-card-printer-name]'
        );

        if (fit && printerName) {
          printerName.textContent =
            context.printer;

          fit.style.display = '';
        }

        /*
         * Ook bij klikken printercontext
         * meenemen.
         */
        card.querySelectorAll('a[href]')
          .forEach((link) => {
            try {
              const url = new URL(
                link.href,
                window.location.origin
              );

              if (
                url.origin ===
                  window.location.origin &&
                url.pathname.startsWith(
                  '/products/'
                )
              ) {
                url.searchParams.set(
                  'printer',
                  context.printer
                );

                link.href =
                  url.pathname +
                  url.search +
                  url.hash;
              }
            } catch (error) {}
          });
      });

      document.dispatchEvent(
        new CustomEvent(
          'ucw:printer-context-ready',
          { detail: context }
        )
      );

      return context;
    })
    .catch(() => {
      context.clear();

      document.dispatchEvent(
        new CustomEvent(
          'ucw:printer-context-ready',
          { detail: context }
        )
      );

      return context;
    });
})();
